import theme from '@efexteam/mui-theme';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import ClientsTableStyles from './ClientsTable.style';
import ClientTableRow from './components/clientTableRow';
import { Client, ClientsTableProps } from './types';

const ClientsTable = ({ clients, onSelect }: ClientsTableProps) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <TableContainer className={ClientsTableStyles.tableContainer}>
      <Table className={clsx('mui-table', ClientsTableStyles.table)}>
        <TableHead className={ClientsTableStyles.tableHead}>
          <TableRow>
            <TableCell
              className={ClientsTableStyles.tableHeaderCell(!isMobile)}
            >
              <Typography variant="caption">{t('clientName')}</Typography>
            </TableCell>
            <TableCell className={ClientsTableStyles.tableHeaderCell()}>
              <Typography variant="caption">{t('companyName')}</Typography>
            </TableCell>
            <TableCell className={ClientsTableStyles.tableHeaderCell()}>
              <Typography variant="caption">{t('email')}</Typography>
            </TableCell>
            <TableCell className={ClientsTableStyles.tableHeaderCell()}>
              <Typography variant="caption">{t('ccAccountNumber')}</Typography>
            </TableCell>
            <TableCell className={ClientsTableStyles.tableHeaderCell()}>
              <Typography variant="caption">{t('bank')}</Typography>
            </TableCell>
            <TableCell className={ClientsTableStyles.tableHeaderCell()}>
              <Typography variant="caption">{t('country')}</Typography>
            </TableCell>
            <TableCell className={ClientsTableStyles.tableHeaderCell()}>
              <Typography variant="caption">{t('status')}</Typography>
            </TableCell>
            <TableCell className={ClientsTableStyles.tableHeaderCell()}>
              <Typography variant="caption">{t('action')}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {clients
            .map((element: Client) => (
              <ClientTableRow
                key={element.id}
                element={element}
                onSelect={onSelect}
              />
            ))
            .reverse()}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ClientsTable;
